import { IconButton, Paper, Stack } from "@mui/material";
import { useViaPoints, useRouteLocationActions } from "../../stores/RouteLocationStore";
import DeleteIcon from '@mui/icons-material/Delete';
import { AddressItem } from "../../services/GeocodeService";

export function ViaPointMenu() {
    const viaPoints = useViaPoints();
    const { removeViaPoint } = useRouteLocationActions();

    const sortedViaPoints = viaPoints.sort( (a,b) => a.order < b.order ? -1:1 )
    return (            
        <>
        {viaPoints && viaPoints.length > 0 &&
            <Stack spacing={1}>
            {
                sortedViaPoints.map( (viaPoint: AddressItem, index: number) => {
                    const name = "Viapunkt: " + viaPoint.name;
                    return (
                        <Paper key={"ViaPointMenu" + index}>
                            <p style={{float:"left"}}>{name}</p>                            
                            <IconButton style={{float: "right", textAlign:"center"}} onClick={ () => {
                                    removeViaPoint(viaPoint)
                                }}>
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Paper>
                    );
                })
            }
            </Stack>        
        }
        </>
        
    )
}